import useViewport from '../common/hooks/useViewport'
import { Element } from '../common/html/element'

export const SCROLL_LAYOUT_ELEMENT_ID = 'SCROLL_LAYOUT_ELEMENT_ID'

export const LayoutContainer = ({ children, className }) => {
  const { height } = useViewport()

  return (
    <Element
      elementName="div"
      id={SCROLL_LAYOUT_ELEMENT_ID}
      style={{
        fontSize: 12,
        backgroundColor: '#FFFFFF',
        color: '#191D25',
        height,
      }}
      className={className}
    >
      {children}
    </Element>
  )
}
